export const CET4_CONFUSABLE = [
  {
    "pair": "economic/economical",
    "words": [
      "economic",
      "economical"
    ],
    "mean": [
      "经济的；经济上的（与经济有关）",
      "节约的，省钱的，划算的"
    ],
    "desc": "· economic 说的是「跟经济有关的」，是中性描述，如 economic growth 经济增长。\n· economical 说的是「省钱的、节约的」，带有褒义，如 an economical car 省油的车。\n· 考场口诀：-ical 结尾多表「性质」，此处＝节约的。",
    "egs": [
      {
        "en": "The boy left school for economic reasons.",
        "zh": "这个男孩因为经济原因辍学了。"
      },
      {
        "en": "To rent a house is more economical than to buy one.",
        "zh": "租房比买房更划算。"
      }
    ]
  },
  {
    "pair": "ensure/insure",
    "words": [
      "ensure",
      "insure"
    ],
    "mean": [
      "确保，保证（保证某事一定会发生）",
      "给……投保，上保险"
    ],
    "desc": "· ensure 是动词「确保、保证」，后面直接接事情：ensure safety 确保安全。\n· insure 是「给……上保险」，美式英语中也可写作 ensure，但四六级常考「投保」义：insure the house against fire。\n· 名词形式注意：insurance 保险，assurance 保证。",
    "egs": [
      {
        "en": "After signing a contract with a professional baseball team, Jack decided to insure his pitching arm for $1 million.",
        "zh": "与职业棒球队签约后，杰克决定为他投球的手臂投保100万美元。"
      },
      {
        "en": "Please ensure (that) all lights are switched off.",
        "zh": "请确保所有的灯都已关掉。"
      },
      {
        "en": "Our precautions ensured our safety.",
        "zh": "我们的预防措施保证了我们的安全。"
      }
    ]
  },
  {
    "pair": "electric/electrical",
    "words": [
      "electric",
      "electrical"
    ],
    "mean": [
      "用电的，电动的（本身靠电驱动）",
      "与电有关的，电气的（不一定带电）"
    ],
    "desc": "· electric 指「本身用电驱动或发电的」：an electric car 电动汽车、an electric shock 触电。\n· electrical 指「与电有关的、电气方面的」，不一定通电：an electrical engineer 电气工程师、electrical appliances 电器。\n· 判断法：能通电干活的用 electric，只是「跟电沾边」的用 electrical。",
    "egs": [
      {
        "en": "electric light",
        "zh": "电灯"
      },
      {
        "en": "Please connect the two electric wires.",
        "zh": "请把这两根电线接上。"
      },
      {
        "en": "electrical engineer",
        "zh": "电气工程师"
      },
      {
        "en": "All the electrical work was done by my younger brother.",
        "zh": "所有的电气活都是我弟弟做的。"
      },
      {
        "en": "He buried himself in an electrical book.",
        "zh": "他埋头读一本电学方面的书。"
      }
    ]
  },
  {
    "pair": "historic/historical",
    "words": [
      "historic",
      "historical"
    ],
    "mean": [
      "有历史意义的，历史性的",
      "历史的，与历史有关的"
    ],
    "desc": "· historic 指「有历史意义的、历史性的」：a historic victory 历史性胜利。\n· historical 指「历史上的、与历史有关的（未必重要）」：a historical novel 历史小说、historical records 史料。\n· 一句话：historic＝载入史册的；historical＝史实的。",
    "egs": [
      {
        "en": "historic sites",
        "zh": "历史名胜（有历史意义的遗址）"
      },
      {
        "en": "a colourful historical period",
        "zh": "一个多姿多彩的历史时期"
      }
    ]
  },
  {
    "pair": "lie/lay",
    "words": [
      "lie",
      "lay"
    ],
    "mean": [
      "①说谎（lied/lied/lying）；②躺、位于（lay/lain/lying）",
      "放、搁；下蛋（laid/laid/laying）"
    ],
    "desc": "· lie 有两个意思，变化形式完全不同：\n　① 说谎 → lied / lied / lying（规则变化）\n　② 躺、位于 → lay / lain / lying（不规则变化）\n· lay 是及物动词「放、搁、下蛋」→ laid / laid / laying，后面必须接宾语。\n· 考场口诀：躺 lie 的过去式是 lay（恰好等于「放」的原形），别被绕晕。",
    "egs": [
      {
        "en": "He lay under a tree to sleep.",
        "zh": "他躺在树下睡觉。"
      },
      {
        "en": "The dog laid its ears back.",
        "zh": "小狗把耳朵耷拉下来。"
      }
    ]
  },
  {
    "pair": "considerable/considerate",
    "words": [
      "considerable",
      "considerate"
    ],
    "mean": [
      "相当多（大）的，可观的",
      "体贴的，体谅的，考虑周到的"
    ],
    "desc": "· considerable 指「相当大（多）的、可观的」，修饰数量程度：a considerable amount of money 相当大一笔钱。\n· considerate 指「体贴的、为他人着想的」，修饰人：It is considerate of you to call first. 你先打个电话真体贴。\n· 词尾记忆：-able 表「可……的」→可观；-ate 常用于形容人的品质→体贴。",
    "egs": [
      {
        "en": "a considerable income",
        "zh": "一笔可观的收入"
      },
      {
        "en": "He met a considerable amount of trouble.",
        "zh": "他遇到了很多麻烦。"
      },
      {
        "en": "It was very considerate of you to send me a birthday card.",
        "zh": "你寄生日卡给我，真是考虑周到。"
      }
    ]
  },
  {
    "pair": "intense/intensive",
    "words": [
      "intense",
      "intensive"
    ],
    "mean": [
      "强烈的，剧烈的（程度很高）",
      "集中的，深入细致的"
    ],
    "desc": "· intense 指「强烈的、剧烈的」，强调程度高：intense pain 剧痛、intense competition 激烈竞争。\n· intensive 指「集中的、深入细致的」，强调投入密集：intensive reading 精读、intensive care 重症监护。\n· 对比例：intense training 强度很大的训练 vs intensive training 密集（高频）训练。",
    "egs": [
      {
        "en": "have intense interest in sth",
        "zh": "对某事有浓厚的兴趣"
      },
      {
        "en": "intensive training",
        "zh": "强化训练"
      }
    ]
  },
  {
    "pair": "raise/rise",
    "words": [
      "raise",
      "rise"
    ],
    "mean": [
      "及物动词：举起，提高，饲养，提出",
      "不及物动词：升起，上升，起床"
    ],
    "desc": "· raise 是及物动词（raise-raised-raised），必须带宾语：举起、提高、筹集、饲养、提出。raise your hand 举手，raise funds 筹款。\n· rise 是不及物动词（rise-rose-risen），不带宾语：上升、升起、上涨、起身。The sun rises in the east. 太阳从东方升起。\n· 快速判断：句子后面直接跟宾语 → raise；没有宾语 → rise。",
    "egs": [
      {
        "en": "He raised his voice.",
        "zh": "他提高了嗓门。"
      },
      {
        "en": "Her wages were raised.",
        "zh": "她涨工资了。"
      },
      {
        "en": "The sun rises in the east.",
        "zh": "太阳从东方升起。"
      }
    ]
  },
  {
    "pair": "invaluable/valueless",
    "words": [
      "invaluable",
      "valueless"
    ],
    "mean": [
      "极宝贵的，价值无法估量的（=priceless）",
      "毫无价值的（=worthless）"
    ],
    "desc": "· invaluable 不是「没有价值的」，而是「价值大到无法估量的、极宝贵的」，同义于 priceless。\n· valueless 才是「毫无价值的」，同义于 worthless。\n· 这是四六级经典陷阱：in- 在此不是否定，而是加强；-less 才是否定后缀。",
    "egs": [
      {
        "en": "Your services are invaluable to us.",
        "zh": "你的帮助对我们极其宝贵。"
      },
      {
        "en": "That book is valueless.",
        "zh": "那本书毫无价值。"
      }
    ]
  },
  {
    "pair": "accident/incident",
    "words": [
      "accident",
      "incident"
    ],
    "mean": [
      "事故（突发、多为不幸事件）",
      "事件、小插曲（程度较轻）"
    ],
    "desc": "· accident 指「意外事故」，多为不幸、造成伤害：a car accident 车祸、by accident 偶然。\n· incident 指「事件、小插曲」，程度较轻，也可指政治性事件：a funny incident 一件趣事、a border incident 边境事件。\n· 程度对照：accident 严重且意外；incident 可大可小但偏中性。",
    "egs": [
      {
        "en": "traffic accident",
        "zh": "交通事故"
      },
      {
        "en": "an international incident",
        "zh": "一次国际事件"
      }
    ]
  },
  {
    "pair": "affect/effect",
    "words": [
      "affect",
      "effect"
    ],
    "mean": [
      "动词：影响，感动",
      "名词：效果，影响"
    ],
    "desc": "· affect 是动词「影响、感动、侵袭」：Smoking affects your health. 吸烟影响健康。\n· effect 通常作名词「影响、效果」：have an effect on … 对……有影响；作动词时意为「实现、促成」，如 effect a change 促成改变。\n· 记忆：a- 开头是动词（affect），e- 开头是名词（effect）；动词「实现」义较少考。",
    "egs": [
      {
        "en": "Smoking affects health.",
        "zh": "吸烟影响健康。"
      },
      {
        "en": "Government policy will not have any effect on us.",
        "zh": "政府的政策不会对我们有任何影响。"
      }
    ]
  },
  {
    "pair": "continuous/continual",
    "words": [
      "continuous",
      "continual"
    ],
    "mean": [
      "持续不断的（中间没有间断）",
      "多次重复的（中间有间隔）"
    ],
    "desc": "· continuous 指「连续不断的」，中间毫无间断：a continuous line of traffic 络绎不绝的车流。\n· continual 指「多次重复的、断断续续的」，中间有间隔：continual interruptions 不停的打扰。\n· 关键区别：continuous＝一次持续到底；continual＝反复发生。",
    "egs": [
      {
        "en": "continuous pain",
        "zh": "持续的疼痛（一直没停）"
      },
      {
        "en": "continual improvements in technology",
        "zh": "技术上的不断进步（一次次改进）"
      }
    ]
  },
  {
    "pair": "conserve/preserve",
    "words": [
      "conserve",
      "preserve"
    ],
    "mean": [
      "保存，节约（强调省着用）",
      "保护，维持（强调不受破坏）"
    ],
    "desc": "· conserve 强调「节约使用、避免浪费」，对象多为资源能源：conserve water 节约用水、conserve energy 节能。\n· preserve 强调「保护使不受破坏、维持原状」，对象多为事物状态：preserve the ancient temple 保护古庙、preserve food 腌制保存食物。\n· 记忆：conserve＝省着用；preserve＝保住不变。",
    "egs": [
      {
        "en": "In winter, some people conserve energy by lowering the heat at night.",
        "zh": "冬天，有些人夜里把暖气调小以节约能源。"
      },
      {
        "en": "The government preserves the rights of the individual person.",
        "zh": "政府保护个人的权利。"
      }
    ]
  },
  {
    "pair": "sensitive/sensible",
    "words": [
      "sensitive",
      "sensible"
    ],
    "mean": [
      "敏感的，易受影响的（-tive 表特性）",
      "明智的，通情达理的；意识到的（-able 表能力）"
    ],
    "desc": "· sensitive 指「敏感的、易受影响的、易生气的」，也可指仪器灵敏：be sensitive to criticism 对批评很敏感。\n· sensible 指「明智的、通情达理的、察觉到的」：a sensible decision 明智的决定；be sensible of the danger 察觉到危险。\n· 词尾规律：-tive 多表「有……倾向/性质」，-able 多表「可……的、具备……能力」。",
    "egs": [
      {
        "en": "a sensitive topic",
        "zh": "敏感话题"
      },
      {
        "en": "a sensible young woman",
        "zh": "一位明智的姑娘"
      },
      {
        "en": "sensible of his fault",
        "zh": "意识到他的错误"
      }
    ]
  },
  {
    "pair": "incredible/incredulous",
    "words": [
      "incredible",
      "incredulous"
    ],
    "mean": [
      "难以置信的，惊人的（形容事物）",
      "不相信的，怀疑的（形容人）"
    ],
    "desc": "· incredible 形容事物「难以置信的、惊人的、极好的」：an incredible story 令人难以置信的故事。\n· incredulous 形容人「不相信的、满脸怀疑的」：an incredulous look 怀疑的表情。\n· 判断法：主语是「事」用 incredible，主语是「人」用 incredulous。",
    "egs": [
      {
        "en": "incredible energy",
        "zh": "惊人的能量/精力"
      },
      {
        "en": "an incredulous look",
        "zh": "怀疑的目光"
      }
    ]
  },
  {
    "pair": "special/specific",
    "words": [
      "special",
      "specific"
    ],
    "mean": [
      "特别的，特殊的（强调与众不同）",
      "特定的，具体的（强调限定性）"
    ],
    "desc": "· special 指「特殊的、特别的、专门的」，强调与众不同或专门用途：a special occasion 特殊场合。\n· specific 指「特定的、具体的、明确的」，强调限定范围和细节：a specific purpose 特定目的、be specific about the time 把时间说具体。\n· 常考搭配：to be specific 具体地说。",
    "egs": [
      {
        "en": "a special friend",
        "zh": "特殊的朋友"
      },
      {
        "en": "His specific problems got him into trouble.",
        "zh": "他特有的问题使自己陷入麻烦。"
      }
    ]
  },
  {
    "pair": "complement/compliment",
    "words": [
      "complement",
      "compliment"
    ],
    "mean": [
      "补足（物）；使完整，相辅相成",
      "赞美，恭维；问候（compliments）"
    ],
    "desc": "· complement 是「补充物、使完整的东西」，也可作动词「补足、相辅相成」：Wine complements the meal well. 酒与这顿饭相得益彰。\n· compliment 是「赞美、恭维」，也可作动词「称赞」，复数是「问候」：give her a compliment 称赞她一句。\n· 拼写区分：complement 中是 e（完整 complete）；compliment 中是 i（我 I 喜欢被夸）。",
    "egs": [
      {
        "en": "The team needs players who complement each other.",
        "zh": "球队需要能相互取长补短的队员。"
      },
      {
        "en": "Please give my compliments to your parents.",
        "zh": "请代我向你的父母问好。"
      }
    ]
  },
  {
    "pair": "stuff/staff",
    "words": [
      "stuff",
      "staff"
    ],
    "mean": [
      "东西，材料，素材",
      "全体职员，员工"
    ],
    "desc": "· stuff 是不可数名词「东西、材料、玩意儿」，泛指物品或内容：What is this sticky stuff? 这黏糊糊的东西是什么？\n· staff 是集合名词「全体职工、员工」，指人：the teaching staff 全体教师、medical staff 医务人员。\n· 一句话：stuff 指物，staff 指人。",
    "egs": [
      {
        "en": "Put that stuff over there.",
        "zh": "把那些东西放在那边。"
      },
      {
        "en": "the nursing staff of a hospital",
        "zh": "医院的护理人员"
      }
    ]
  },
  {
    "pair": "conducive/conductive",
    "words": [
      "conducive",
      "conductive"
    ],
    "mean": [
      "有益的，有助于……的（常接 to）",
      "导电的，导热的"
    ],
    "desc": "· conducive 是形容词「有益于……的、有助于……的」，常接 to：be conducive to health 有益健康。\n· conductive 是形容词「导电的、导热的」，用于物理属性：a conductive material 导电材料。\n· 注意：conducive to 是四六级高频搭配，to 是介词，后面接名词或动名词。",
    "egs": [
      {
        "en": "Exercise is conducive to health.",
        "zh": "运动有益于健康。"
      },
      {
        "en": "We should create an atmosphere conducive to study.",
        "zh": "我们应创造有助于学习的氛围。"
      },
      {
        "en": "Copper wires are highly conductive.",
        "zh": "铜线的导电性能很好。"
      }
    ]
  },
  {
    "pair": "confidant/confident",
    "words": [
      "confidant",
      "confident"
    ],
    "mean": [
      "名词：知己，心腹之交",
      "形容词：自信的，确信的"
    ],
    "desc": "· confidant 是名词「知己、密友、心腹」，指可以倾诉秘密的人（女性形式 confidante）。\n· confident 是形容词「自信的、确信的」，常用 be confident of / that…：I am confident that I will succeed. 我相信我会成功。\n· 词性区分：名词是「人」，形容词是「心态」。",
    "egs": [
      {
        "en": "He is my confidant.",
        "zh": "他是我的心腹之交。"
      },
      {
        "en": "I am confident of success.",
        "zh": "我对成功充满信心。"
      },
      {
        "en": "He feels confident of passing the examination.",
        "zh": "他确信能通过考试。"
      }
    ]
  },
  {
    "pair": "resist/persist",
    "words": [
      "resist",
      "persist"
    ],
    "mean": [
      "抵抗，抵制（抗拒外物）",
      "坚持，持续存在（一直延续）"
    ],
    "desc": "· resist 是「抵抗、抵制、忍住」，及物，后接对象：resist the temptation 抵挡诱惑、resist arrest 拒捕。\n· persist 是「坚持、执意、持续存在」，不及物，常接 in：persist in doing sth. 坚持做某事。\n· 方向感：resist 向外挡（抗拒外物），persist 向内撑（一直延续）。",
    "egs": [
      {
        "en": "Lack of proper nourishment reduces their power to resist disease.",
        "zh": "营养不良降低了他们抵抗疾病的能力。"
      },
      {
        "en": "On the tops of very high mountains snow persists throughout the year.",
        "zh": "高山顶上，积雪终年不化。"
      }
    ]
  },
  {
    "pair": "technology/technique",
    "words": [
      "technology",
      "technique"
    ],
    "mean": [
      "科技、工艺的总称（较抽象，成体系）",
      "技巧、技法（较具体，指某项手艺）"
    ],
    "desc": "· technology 是「科技、工艺、技术」的总称，较抽象、成体系：information technology 信息技术。\n· technique 是「技巧、技法、手法」，较具体，指某项手艺或操作方法：a new painting technique 一种新的绘画技法。\n· 对照：technology 是「技术大类」，technique 是「具体招式」。",
    "egs": [
      {
        "en": "a pianist with superb technique",
        "zh": "技艺精湛的钢琴家"
      },
      {
        "en": "information technology",
        "zh": "信息技术"
      }
    ]
  },
  {
    "pair": "principal/principle",
    "words": [
      "principal",
      "principle"
    ],
    "mean": [
      "形容词：最重要的；名词：校长、本金",
      "名词：原则，原理，定律"
    ],
    "desc": "· principal 作形容词是「最重要的、主要的」（the principal reason 主要原因），作名词是「校长、负责人、本金」。\n· principle 只作名词「原则、原理、准则」：stick to one's principles 坚守原则。\n· 拼写口诀：校长是「pal」（朋友）以 pal 结尾；原则是以 ple 结尾（与 rule 押韵）。",
    "egs": [
      {
        "en": "The principal reason for my decision was the money.",
        "zh": "我做决定的主要原因是钱。"
      },
      {
        "en": "It's the first principle of aerodynamics.",
        "zh": "这是空气动力学的第一定律。"
      }
    ]
  },
  {
    "pair": "transfer/transmit",
    "words": [
      "transfer",
      "transmit"
    ],
    "mean": [
      "转移，调动，转让（侧重位置/所有权变化）",
      "传输，传播，发射（侧重信号传递）"
    ],
    "desc": "· transfer 侧重「位置、归属的转移」：转学、调动、转账、换乘。transfer to another department 调到另一个部门。\n· transmit 侧重「信号、信息、疾病的传播」：传输、发射、传染。transmit data 传输数据。\n· 一句话：transfer＝挪地方；transmit＝传信号。",
    "egs": [
      {
        "en": "He transferred the package from one hand to the other.",
        "zh": "他把包裹从一只手换到另一只手。"
      },
      {
        "en": "I transferred from Rutgers to Tulane.",
        "zh": "我从罗格斯大学转到杜兰大学。"
      },
      {
        "en": "signals transmitted from a satellite",
        "zh": "从卫星传送来的信号"
      }
    ]
  }
];
export const CET4_RARE = [
  {
    "w": "mean",
    "c": "v. 意味着；意思是",
    "r": "adj. 卑鄙的，吝啬的 n. 平均值",
    "e": "Don't be so mean to your little brother.",
    "ez": "别对你弟弟那么刻薄。"
  },
  {
    "w": "found",
    "c": "find 的过去式（找到）",
    "r": "v. 建立，创办",
    "e": "The old university was founded in 1898.",
    "ez": "这所古老的大学创建于1898年。"
  },
  {
    "w": "base",
    "c": "n. 基础，基地",
    "r": "adj. 卑鄙的，不道德的",
    "e": "Cheating in the exam is a base behavior.",
    "ez": "考试作弊是卑鄙的行为。"
  },
  {
    "w": "leave",
    "c": "v. 离开",
    "r": "n. 许可，准假",
    "e": "She asked for three days' leave to care for her mother.",
    "ez": "她请了三天假照顾母亲。"
  },
  {
    "w": "course",
    "c": "n. 课程；过程",
    "r": "v. 跑过，穿过；n. 路线",
    "e": "The blood courses through the whole body.",
    "ez": "血液流经全身。"
  },
  {
    "w": "interest",
    "c": "n. 兴趣",
    "r": "n. 利息；股份",
    "e": "The bank pays 3% interest on savings.",
    "ez": "银行支付3%的存款利息。"
  },
  {
    "w": "account",
    "c": "n. 账户",
    "r": "n. 解释，描述 v. 导致（account for）",
    "e": "He gave a full account of the accident.",
    "ez": "他对事故做了完整的叙述。"
  },
  {
    "w": "address",
    "c": "n. 地址",
    "r": "v. 处理；发表演说",
    "e": "The mayor will address the issue of traffic jams.",
    "ez": "市长将着手解决交通拥堵问题。"
  },
  {
    "w": "subject",
    "c": "n. 主题，科目",
    "r": "v. 使服从，使遭受（be subject to）",
    "e": "No employee shall be subject to unfair treatment.",
    "ez": "任何员工都不应遭受不公平对待。"
  },
  {
    "w": "cause",
    "c": "n. 原因",
    "r": "n. 事业",
    "e": "She devoted her life to the cause of education.",
    "ez": "她毕生献给教育事业。"
  },
  {
    "w": "rule",
    "c": "n. 规则",
    "r": "v. 统治，支配",
    "e": "The king ruled the country for forty years.",
    "ez": "国王统治了这个国家四十年。"
  },
  {
    "w": "term",
    "c": "n. 学期",
    "r": "n. 术语，条款 v. 把…称为",
    "e": "Doctors use medical terms that patients seldom know.",
    "ez": "医生使用的术语病人很少懂。"
  },
  {
    "w": "object",
    "c": "n. 物体",
    "r": "v. 反对（object to）",
    "e": "Many residents object to the new parking fees.",
    "ez": "许多居民反对新的停车收费。"
  },
  {
    "w": "present",
    "c": "adj. 出席的；现在的",
    "r": "v. 提出，呈现；n. 礼物",
    "e": "The team will present its findings on Friday.",
    "ez": "团队将在周五呈现其研究结果。"
  },
  {
    "w": "essay",
    "c": "n. 论文，散文",
    "r": "v. 尝试",
    "e": "She essayed a smile though she was tired.",
    "ez": "尽管累了，她努力挤出一个微笑。"
  },
  {
    "w": "author",
    "c": "n. 作者",
    "r": "v. 编写，创作",
    "e": "He authored three books on modern art.",
    "ez": "他写了三本关于现代艺术的书。"
  },
  {
    "w": "drive",
    "c": "v. 开车",
    "r": "n. 路，干劲 v. 迫使",
    "e": "Hunger drove him to steal bread.",
    "ez": "饥饿驱使他偷面包。"
  },
  {
    "w": "mental",
    "c": "adj. 精神的，脑力的",
    "r": "n. 精神病患者",
    "e": "The hospital built a new ward for mentals.",
    "ez": "医院为精神病患者建了新病区。"
  },
  {
    "w": "plant",
    "c": "n. 植物",
    "r": "n. 工厂 v. 栽种",
    "e": "The power plant provides jobs for the whole town.",
    "ez": "发电厂为全镇提供工作岗位。"
  },
  {
    "w": "firm",
    "c": "adj. 坚定的",
    "r": "n. 公司，商行",
    "e": "He joined a well-known law firm in London.",
    "ez": "他加入了伦敦一家知名律师事务所。"
  },
  {
    "w": "matter",
    "c": "n. 事情",
    "r": "v. 要紧，有关系",
    "e": "It doesn't matter whether you win or lose.",
    "ez": "输赢并不重要。"
  },
  {
    "w": "school",
    "c": "n. 学校",
    "r": "n. 学派；鱼群",
    "e": "A school of fish swam past the divers.",
    "ez": "一群鱼从潜水员身边游过。"
  },
  {
    "w": "capital",
    "c": "n. 首都",
    "r": "n. 资本，资金 adj. 大写的",
    "e": "The startup needs more capital to grow.",
    "ez": "这家初创企业需要更多资本来成长。"
  },
  {
    "w": "diet",
    "c": "n. 日常饮食；节食",
    "r": "n. （日本等国的）国会",
    "e": "The Japanese Diet passed the new budget.",
    "ez": "日本国会通过了新预算。"
  },
  {
    "w": "major",
    "c": "adj. 主要的",
    "r": "n. 少校；主修科目 v. 主修",
    "e": "He majors in computer science at college.",
    "ez": "他在大学主修计算机科学。"
  },
  {
    "w": "general",
    "c": "adj. 普遍的，总的",
    "r": "n. 将军",
    "e": "The general commanded the army with great skill.",
    "ez": "将军出色地指挥了军队。"
  },
  {
    "w": "cell",
    "c": "n. 细胞",
    "r": "n. 电池；单人牢房",
    "e": "The prisoner spent years in a dark cell.",
    "ez": "囚犯在阴暗的牢房里度过了多年。"
  },
  {
    "w": "board",
    "c": "n. 木板",
    "r": "n. 董事会 v. 登（机、船）",
    "e": "We boarded the plane shortly after midnight.",
    "ez": "午夜后不久我们登上了飞机。"
  },
  {
    "w": "count",
    "c": "v. 计算",
    "r": "n. 伯爵 v. 重要",
    "e": "Every vote counts in this election.",
    "ez": "这次选举中每一票都很重要。"
  },
  {
    "w": "stage",
    "c": "n. 阶段",
    "r": "v. 上演，举行 n. 舞台",
    "e": "The city staged a grand light show for the festival.",
    "ez": "城市为节日举办了盛大的灯光秀。"
  },
  {
    "w": "treat",
    "c": "v. 对待",
    "r": "v. 治疗；请客 n. 款待",
    "e": "Let me treat you to dinner tonight.",
    "ez": "今晚我请你吃饭。"
  },
  {
    "w": "miss",
    "c": "v. 错过",
    "r": "n. 小姐 v. 想念",
    "e": "She still misses her hometown deeply.",
    "ez": "她仍然深深想念家乡。"
  },
  {
    "w": "bill",
    "c": "n. 账单",
    "r": "n. 议案；钞票",
    "e": "The new bill will be debated next week.",
    "ez": "新议案下周将进入辩论。"
  },
  {
    "w": "raise",
    "c": "v. 举起",
    "r": "v. 饲养；筹集；提出",
    "e": "The farmer raises sheep and chickens.",
    "ez": "农民养了羊和鸡。"
  },
  {
    "w": "yield",
    "c": "v. 生产",
    "r": "v. 屈服 n. 收益",
    "e": "He refused to yield to the pressure.",
    "ez": "他拒绝向压力屈服。"
  },
  {
    "w": "discipline",
    "c": "n. 纪律",
    "r": "v. 训练，惩罚 n. 学科",
    "e": "Parents should discipline children with patience, not anger.",
    "ez": "父母应当耐心管教孩子，而不是发火。"
  },
  {
    "w": "faculty",
    "c": "n. 才能",
    "r": "n. 全体教员；（大学）系",
    "e": "The faculty meeting is held every Monday.",
    "ez": "全体教员会议每周一举行。"
  },
  {
    "w": "abstract",
    "c": "adj. 抽象的",
    "r": "n. 摘要 v. 提取",
    "e": "Write a short abstract for your paper first.",
    "ez": "先为你的论文写一个简短的摘要。"
  },
  {
    "w": "deliberate",
    "c": "adj. 故意的",
    "r": "v. 深思熟虑",
    "e": "The committee deliberated for hours before voting.",
    "ez": "委员会深思熟虑了数小时才投票。"
  },
  {
    "w": "domestic",
    "c": "adj. 国内的；家庭的",
    "r": "n. 佣人，家佣",
    "e": "The rich family employed three domestics.",
    "ez": "这个富裕家庭雇了三个家佣。"
  },
  {
    "w": "execute",
    "c": "v. 实施，执行",
    "r": "v. 将……处死",
    "e": "The criminal was executed according to law.",
    "ez": "罪犯被依法处决。"
  },
  {
    "w": "fancy",
    "c": "v. 喜欢；n. 想象力",
    "r": "adj. 花哨的，昂贵的",
    "e": "They stayed in a fancy hotel by the sea.",
    "ez": "他们住在一家豪华的海滨酒店。"
  },
  {
    "w": "margin",
    "c": "n. 边缘",
    "r": "n. 页边的空白；余地",
    "e": "Write your notes in the margin of the page.",
    "ez": "把笔记写在页边的空白处。"
  },
  {
    "w": "motion",
    "c": "n. 动作",
    "r": "n. 提议 v. 打手势",
    "e": "The proposal passed by a motion of the committee.",
    "ez": "提议经委员会动议通过。"
  },
  {
    "w": "outlet",
    "c": "n. 出口",
    "r": "n. 批发商店；发泄途径",
    "e": "The brand opened a new outlet in the mall.",
    "ez": "该品牌在商场开了新店。"
  },
  {
    "w": "prime",
    "c": "adj. 主要的",
    "r": "n. 盛年，鼎盛时期",
    "e": "She is an athlete in her prime.",
    "ez": "她是正值巅峰期的运动员。"
  },
  {
    "w": "recall",
    "c": "v. 回忆",
    "r": "v. 召回，收回",
    "e": "The company recalled all the faulty cars.",
    "ez": "公司召回了所有有缺陷的汽车。"
  },
  {
    "w": "reserve",
    "c": "n. 自然保护区；储备",
    "r": "v. 预定",
    "e": "We reserved a table for two by the window.",
    "ez": "我们订了一个靠窗的两人位。"
  },
  {
    "w": "resume",
    "c": "v. 恢复，重新开始",
    "r": "n. 简历",
    "e": "Remember to attach your resume to the email.",
    "ez": "记得把简历附在邮件里。"
  },
  {
    "w": "stable",
    "c": "adj. 稳定的",
    "r": "n. 马厩",
    "e": "The horses were resting in the stable.",
    "ez": "马匹正在马厩里休息。"
  },
  {
    "w": "resort",
    "c": "v. 诉诸（resort to）",
    "r": "n. 度假胜地",
    "e": "The seaside resort is crowded every summer.",
    "ez": "这个海滨度假村每年夏天都人满为患。"
  },
  {
    "w": "career",
    "c": "n. 职业，事业",
    "r": "v. 飞奔，疾驰",
    "e": "The horse careered past the finishing line.",
    "ez": "那匹马飞奔着冲过终点线。"
  },
  {
    "w": "minor",
    "c": "adj. 次要的，较小的",
    "r": "n.（大学）辅修科目",
    "e": "She chose history as her minor.",
    "ez": "她选择历史作为辅修科目。"
  },
  {
    "w": "claim",
    "c": "v. 声称，宣称",
    "r": "n. 索赔；认领",
    "e": "You can make a claim for the lost luggage.",
    "ez": "你可以为丢失的行李提出索赔。"
  },
  {
    "w": "decay",
    "c": "v. 腐烂，腐朽",
    "r": "v./n. 衰减，衰退",
    "e": "Our memory decays quickly without review.",
    "ez": "不复习的话记忆会迅速衰退。"
  },
  {
    "w": "display",
    "c": "n./v. 展示，陈列",
    "r": "n. 显示器；v. 显示（屏幕）",
    "e": "The screen displays your reading progress.",
    "ez": "屏幕会显示你的阅读进度。"
  },
  {
    "w": "infant",
    "c": "n. 婴儿",
    "r": "adj. 初期的，初创的",
    "e": "The company is still in its infant stage.",
    "ez": "这家公司仍处于初创阶段。"
  },
  {
    "w": "label",
    "c": "n. 标签，商标",
    "r": "v. 贴标签；把……归类为",
    "e": "He was labelled as a difficult student.",
    "ez": "他被贴上了「问题学生」的标签。"
  },
  {
    "w": "disgust",
    "c": "n. 厌恶，反感",
    "r": "v. 使厌恶，使作呕",
    "e": "The dirty kitchen disgusted everyone.",
    "ez": "脏乱的厨房让所有人都反感。"
  },
  {
    "w": "climax",
    "c": "n. 顶点，高潮",
    "r": "v.（使）达到顶点",
    "e": "The concert climaxed with a fireworks show.",
    "ez": "音乐会以烟火表演达到高潮。"
  },
  {
    "w": "produce",
    "c": "v. 生产，制造",
    "r": "n. 产品，（尤指）农产品",
    "e": "Fresh local produce is sold here every morning.",
    "ez": "每天早晨这里都卖新鲜的本地农产品。"
  },
  {
    "w": "grain",
    "c": "n. 谷物，谷粒",
    "r": "n. 纹理，颗粒",
    "e": "The wood has a very fine grain.",
    "ez": "这种木头的纹理很细腻。"
  },
  {
    "w": "program",
    "c": "n. 节目，计划",
    "r": "v. 编制程序；设定",
    "e": "The washing machine is programmed to start at seven.",
    "ez": "洗衣机被设定在七点启动。"
  },
  {
    "w": "social",
    "c": "adj. 社会的",
    "r": "n. 社交聚会",
    "e": "The company holds a social every December.",
    "ez": "公司每年十二月举办一次联谊会。"
  },
  {
    "w": "through",
    "c": "prep. 穿过，通过",
    "r": "adj. 直达的；完成的；（电话）接通的",
    "e": "Is the train through to Shanghai without a stop?",
    "ez": "这趟火车是直达上海、中途不停的吗？"
  },
  {
    "w": "common",
    "c": "adj. 常见的，共同的",
    "r": "n. 公地，公共用地",
    "e": "People used to keep sheep on the village common.",
    "ez": "过去人们在村子的公共牧地上放羊。"
  },
  {
    "w": "report",
    "c": "n./v. 报告",
    "r": "v. 报到；举报",
    "e": "You should report to the office at eight.",
    "ez": "你应该八点到办公室报到。"
  },
  {
    "w": "offer",
    "c": "v. 提供，提出",
    "r": "n. 出价，报价",
    "e": "They made an offer of two million for the house.",
    "ez": "他们出价两百万买这栋房子。"
  },
  {
    "w": "chain",
    "c": "n. 链子，链条",
    "r": "v. 用铁链锁住；束缚",
    "e": "The gates were chained shut at night.",
    "ez": "夜里大门用铁链锁上了。"
  },
  {
    "w": "ancient",
    "c": "adj. 古代的，古老的",
    "r": "n. 古人",
    "e": "The ancients believed the earth was flat.",
    "ez": "古人认为地球是平的。"
  },
  {
    "w": "support",
    "c": "v. 支持，支撑",
    "r": "v. 供养，赡养",
    "e": "He works two jobs to support his family.",
    "ez": "他打两份工来养家。"
  },
  {
    "w": "record",
    "c": "n. 记录，记载",
    "r": "v. 录音；n. 唱片",
    "e": "She recorded the whole performance on her phone.",
    "ez": "她用手机录下了整场演出。"
  },
  {
    "w": "order",
    "c": "n. 命令，顺序",
    "r": "v. 订购；n. 订单",
    "e": "We ordered three copies of the textbook online.",
    "ez": "我们在网上订购了三本教材。"
  },
  {
    "w": "nurse",
    "c": "n. 护士",
    "r": "v. 护理，看护；培育",
    "e": "She nursed her mother back to health.",
    "ez": "她照料母亲直到康复。"
  },
  {
    "w": "return",
    "c": "v. 返回，归还",
    "r": "n.（投资）回报，收益",
    "e": "The investment gave a return of eight percent.",
    "ez": "这笔投资的回报率是百分之八。"
  },
  {
    "w": "process",
    "c": "n. 过程，进程",
    "r": "v. 加工，处理；起诉",
    "e": "The factory processes raw milk every morning.",
    "ez": "工厂每天早晨加工原奶。"
  },
  {
    "w": "concern",
    "c": "n. 关心，担心",
    "r": "v. 涉及，与……有关",
    "e": "This notice concerns all first-year students.",
    "ez": "这份通知涉及所有大一学生。"
  },
  {
    "w": "message",
    "c": "n. 消息，信息",
    "r": "v. 发消息，通讯",
    "e": "Just message me when you get home.",
    "ez": "你到家就给我发个消息。"
  },
  {
    "w": "benefit",
    "c": "n. 好处，利益",
    "r": "v. 有益于；n. 津贴",
    "e": "The new rule benefits part-time workers most.",
    "ez": "新规定对兼职人员最有利。"
  },
  {
    "w": "break",
    "c": "v. 打破，折断",
    "r": "n. 休息，间歇",
    "e": "Let's have a short break after this chapter.",
    "ez": "学完这章我们休息一会儿。"
  },
  {
    "w": "force",
    "c": "n. 力，力量",
    "r": "n. 部队，武装力量",
    "e": "Both sides sent more troops and police forces.",
    "ez": "双方都增派了部队和警力。"
  },
  {
    "w": "supply",
    "c": "v. 供应，供给",
    "r": "n. 补给，贮备",
    "e": "The town ran short of food supplies in winter.",
    "ez": "这个镇冬天食物储备不足。"
  },
  {
    "w": "advance",
    "c": "v. 前进，推进",
    "r": "n. 预付款；adj. 预先的",
    "e": "He asked for an advance on his salary.",
    "ez": "他请求预支一部分工资。"
  },
  {
    "w": "amount",
    "c": "n. 数量，总额",
    "r": "v. 总计，等于",
    "e": "The bill amounts to more than five hundred yuan.",
    "ez": "账单总计五百多元。"
  },
  {
    "w": "feed",
    "c": "v. 喂养，饲养",
    "r": "n. 饲料；一餐",
    "e": "The farmer stored feed for the long winter.",
    "ez": "农场主为漫长的冬天储备了饲料。"
  },
  {
    "w": "effect",
    "c": "n. 影响，效果",
    "r": "v. 引起，使产生",
    "e": "The medicine effected a rapid improvement.",
    "ez": "这种药带来了迅速的好转。"
  },
  {
    "w": "level",
    "c": "n. 水平，等级",
    "r": "v. 弄平，夷平",
    "e": "The old houses were levelled to build a mall.",
    "ez": "旧房子被推平以建商场。"
  },
  {
    "w": "economy",
    "c": "n. 经济",
    "r": "adj. 经济的，廉价的",
    "e": "It is more economy to cook at home.",
    "ez": "在家做饭更省钱。"
  },
  {
    "w": "sense",
    "c": "n. 感觉，意识",
    "r": "n. 意义，道理；v. 检测",
    "e": "There is no sense in arguing with him.",
    "ez": "跟他争辩没有意义。"
  },
  {
    "w": "crop",
    "c": "n. 农作物，收成",
    "r": "v. 收割，修剪；（问题）出现",
    "e": "New problems cropped up at the last minute.",
    "ez": "最后一刻又冒出了新问题。"
  },
  {
    "w": "divide",
    "c": "v. 划分，分开",
    "r": "n. 分水岭，分歧",
    "e": "Money is the main divide between the two sides.",
    "ez": "钱是双方分歧的主要所在。"
  },
  {
    "w": "score",
    "c": "n. 得分，分数",
    "r": "v. 得分；n. 二十",
    "e": "A score of students waited outside the hall.",
    "ez": "二十名学生在礼堂外等候。"
  },
  {
    "w": "daily",
    "c": "adj. 日常的，每日的",
    "r": "n. 日报",
    "e": "He read the news in a local daily.",
    "ez": "他在一份当地日报上读到这则新闻。"
  },
  {
    "w": "expert",
    "c": "n. 专家，能手",
    "r": "adj. 熟练的，内行的",
    "e": "She is expert at dealing with difficult clients.",
    "ez": "她很擅长应付难缠的客户。"
  },
  {
    "w": "pattern",
    "c": "n. 图案，式样",
    "r": "n. 模式，规律；v. 仿造",
    "e": "The app was patterned on a famous dictionary.",
    "ez": "这款应用是仿照一本著名词典做的。"
  },
  {
    "w": "project",
    "c": "n. 项目，工程",
    "r": "v. 投射，放映；预测",
    "e": "The teacher projected the slides onto the wall.",
    "ez": "老师把幻灯片投射到墙上。"
  },
  {
    "w": "source",
    "c": "n. 来源，源头",
    "r": "v. 从……获得",
    "e": "Most of the data is sourced from public reports.",
    "ez": "大部分数据取自公开报告。"
  },
  {
    "w": "share",
    "c": "v. 分享，分担",
    "r": "n. 股份，份额",
    "e": "She owns a small share in the company.",
    "ez": "她在这家公司持有少量股份。"
  },
  {
    "w": "factor",
    "c": "n. 因素，要素",
    "r": "n.（数学）因子，因数",
    "e": "Three and five are factors of fifteen.",
    "ez": "三和五是十五的因数。"
  },
  {
    "w": "motor",
    "c": "n. 发动机，马达",
    "r": "adj. 汽车的；运动神经的",
    "e": "The patient's motor skills improved after training.",
    "ez": "训练后患者的运动神经功能改善了。"
  },
  {
    "w": "short",
    "c": "adj. 短的，矮的",
    "r": "n. 短片；烈酒",
    "e": "They showed a short before the main film.",
    "ez": "正片前放映了一部短片。"
  },
  {
    "w": "reach",
    "c": "v. 到达，伸手够到",
    "r": "n. 影响范围，可及范围",
    "e": "The medicine should be kept out of children's reach.",
    "ez": "药品应放在儿童够不到的地方。"
  },
  {
    "w": "freeze",
    "c": "v. 冻结，结冰",
    "r": "v.（因害怕等）僵住",
    "e": "She froze when she heard the sudden noise.",
    "ez": "听到突然的声响，她一下子僵住了。"
  },
  {
    "w": "measure",
    "c": "v. 测量，衡量",
    "r": "n. 措施，办法",
    "e": "The city took strong measures against pollution.",
    "ez": "这座城市采取了有力措施治理污染。"
  },
  {
    "w": "average",
    "c": "n. 平均数",
    "r": "adj. 普通的，一般的",
    "e": "He is just an average student in the class.",
    "ez": "他只是班里一名普通的学生。"
  },
  {
    "w": "waste",
    "c": "n. 废物；v. 浪费",
    "r": "adj. 荒芜的，废弃的",
    "e": "They turned waste land into a community garden.",
    "ez": "他们把荒地改造成了社区花园。"
  },
  {
    "w": "bite",
    "c": "v. 咬，叮",
    "r": "n. 一口；（咬的）伤口",
    "e": "Take a bite and tell me how it tastes.",
    "ez": "尝一口，告诉我味道如何。"
  },
  {
    "w": "abroad",
    "c": "adv. 在国外",
    "r": "adv. 广为流传，四处",
    "e": "Rumours about the exam spread abroad overnight.",
    "ez": "关于这场考试的传言一夜之间传开了。"
  },
  {
    "w": "brain",
    "c": "n. 脑，大脑",
    "r": "n. 智者；控制中心",
    "e": "She is the brain behind the whole project.",
    "ez": "她是整个项目背后的智囊。"
  },
  {
    "w": "build",
    "c": "v. 建造，创建",
    "r": "n. 体格，身材",
    "e": "He has the build of a professional swimmer.",
    "ez": "他有着职业游泳运动员的体格。"
  },
  {
    "w": "plastic",
    "c": "n. 塑料",
    "r": "adj. 可塑的；整形的",
    "e": "She works in a plastic surgery hospital.",
    "ez": "她在一家整形医院工作。"
  },
  {
    "w": "serve",
    "c": "v. 服务，侍候",
    "r": "v. 可作……用；n. 发球",
    "e": "The sofa can serve as a bed for guests.",
    "ez": "这张沙发可以当客人的床用。"
  },
  {
    "w": "contact",
    "c": "n. 联系，接触",
    "r": "n. 熟人，人脉",
    "e": "He has many contacts in the publishing business.",
    "ez": "他在出版业有很多人脉。"
  },
  {
    "w": "demand",
    "c": "n. 需求，要求",
    "r": "v. 查问，盘问",
    "e": "The guard demanded to see our passes.",
    "ez": "保安要求查看我们的通行证。"
  },
  {
    "w": "purpose",
    "c": "n. 目的，意图",
    "r": "v. 打算，决意",
    "e": "They purpose to finish the work by Friday.",
    "ez": "他们打算周五前完成这项工作。"
  },
  {
    "w": "remain",
    "c": "v. 保持，留下",
    "r": "n. 遗迹，残骸",
    "e": "The remains of the old wall can still be seen.",
    "ez": "古墙的遗迹至今仍可见。"
  },
  {
    "w": "worth",
    "c": "adj. 值得的",
    "r": "n. 价值，财富",
    "e": "The painting is of great worth to collectors.",
    "ez": "这幅画对收藏家很有价值。"
  },
  {
    "w": "pretty",
    "c": "adj. 漂亮的",
    "r": "adv. 相当，颇",
    "e": "The exam was pretty difficult this time.",
    "ez": "这次考试相当难。"
  },
  {
    "w": "combine",
    "c": "v. 结合，联合",
    "r": "n. 联合收割机；集团",
    "e": "The farm bought a new combine last year.",
    "ez": "农场去年买了台新联合收割机。"
  },
  {
    "w": "plenty",
    "c": "n. 大量，充足",
    "r": "adv. 充分，非常",
    "e": "Drink plenty of water before the exam.",
    "ez": "考前要多喝水。"
  },
  {
    "w": "prison",
    "c": "n. 监狱",
    "r": "v. 囚禁，关押",
    "e": "He was prisoned for five years.",
    "ez": "他被关押了五年。"
  },
  {
    "w": "range",
    "c": "n. 范围，幅度",
    "r": "n. 山脉；射程 v. 排列",
    "e": "A range of mountains lies north of the city.",
    "ez": "城北横亘着一列山脉。"
  },
  {
    "w": "select",
    "c": "v. 选择，挑选",
    "r": "adj. 精选的，优等的",
    "e": "Only a select few were invited to the meeting.",
    "ez": "只有少数经过挑选的人获邀参会。"
  },
  {
    "w": "chief",
    "c": "adj. 主要的，首要的",
    "r": "n. 首领，长官",
    "e": "The chief of the police gave a short speech.",
    "ez": "警察局长作了简短讲话。"
  },
  {
    "w": "hunger",
    "c": "n. 饥饿",
    "r": "v. 渴望",
    "e": "Young people hunger for real experience.",
    "ez": "年轻人渴望真正的经历。"
  },
  {
    "w": "list",
    "c": "n. 名单，清单",
    "r": "v.（船）倾斜",
    "e": "The ship listed badly to one side.",
    "ez": "船严重向一侧倾斜。"
  },
  {
    "w": "snack",
    "c": "n. 小吃，点心",
    "r": "v. 吃零食",
    "e": "She snacks on fruit instead of chips.",
    "ez": "她用水果代替薯片当零食。"
  },
  {
    "w": "traffic",
    "c": "n. 交通，车流",
    "r": "n. 非法交易；v. 做违法生意",
    "e": "He was arrested for trafficking in drugs.",
    "ez": "他因贩毒被捕。"
  },
  {
    "w": "trick",
    "c": "n. 诡计，花招",
    "r": "n. 诀窍，技巧",
    "e": "The trick is to review before you sleep.",
    "ez": "诀窍是睡前复习一遍。"
  },
  {
    "w": "aim",
    "c": "n. 目标，目的",
    "r": "v. 旨在，瞄准",
    "e": "The course aims to improve spoken English.",
    "ez": "这门课旨在提高英语口语。"
  },
  {
    "w": "design",
    "c": "n. 设计，图案",
    "r": "n. 目的，图谋",
    "e": "He had designs on the manager's position.",
    "ez": "他对经理的位子有图谋。"
  },
  {
    "w": "figure",
    "c": "n. 数字，图形",
    "r": "v. 认为，估计；n. 人物",
    "e": "I figure it will take about two hours.",
    "ez": "我估计大约要两个小时。"
  },
  {
    "w": "fuel",
    "c": "n. 燃料",
    "r": "v. 加燃料；刺激",
    "e": "The report fuelled public anger.",
    "ez": "这份报道激起了公众的愤怒。"
  },
  {
    "w": "gain",
    "c": "v. 获得，增加",
    "r": "n. 收益，增益",
    "e": "The gains were much smaller than expected.",
    "ez": "收益比预期小得多。"
  },
  {
    "w": "harvest",
    "c": "n. 收获，收成",
    "r": "v. 收割，收获",
    "e": "Farmers harvest the wheat in early June.",
    "ez": "农民在六月初收割小麦。"
  },
  {
    "w": "instant",
    "c": "adj. 立即的",
    "r": "n. 瞬间；adj. 速食的",
    "e": "He answered in an instant without thinking.",
    "ez": "他不假思索地瞬间作答。"
  },
  {
    "w": "link",
    "c": "v. 联系，连接",
    "r": "n. 环节，环",
    "e": "The weakest link of the plan is money.",
    "ez": "这个计划最薄弱的环节是资金。"
  },
  {
    "w": "local",
    "c": "adj. 当地的，本地的",
    "r": "n. 当地人",
    "e": "The locals are very friendly to visitors.",
    "ez": "当地人对游客很友好。"
  },
  {
    "w": "machine",
    "c": "n. 机器",
    "r": "v. 用机器制造",
    "e": "The parts are machined in a nearby factory.",
    "ez": "零件在附近工厂用机器加工。"
  },
  {
    "w": "main",
    "c": "adj. 主要的",
    "r": "n. 总管道，干线",
    "e": "The water main broke near the school gate.",
    "ez": "校门附近的主水管破裂了。"
  },
  {
    "w": "model",
    "c": "n. 模型，模范",
    "r": "n. 模特儿；v. 塑造",
    "e": "She models for a small fashion brand.",
    "ez": "她为一家小时装品牌当模特。"
  },
  {
    "w": "patient",
    "c": "n. 病人",
    "r": "adj. 有耐心的",
    "e": "Be patient with slow learners.",
    "ez": "对学得慢的人要有耐心。"
  },
  {
    "w": "post",
    "c": "n. 邮件，邮政",
    "r": "n. 职位；v. 派遣",
    "e": "He was posted to the company's Beijing office.",
    "ez": "他被派往公司驻北京的办事处。"
  },
  {
    "w": "cover",
    "c": "v. 覆盖",
    "r": "v. 涉及，报道",
    "e": "The book covers every CET-4 grammar point.",
    "ez": "这本书涵盖四级全部语法点。"
  },
  {
    "w": "deal",
    "c": "n. 交易，协议",
    "r": "v. 处理，应付；n. 大量",
    "e": "She has a great deal of patience with children.",
    "ez": "她对孩子很有耐心。"
  },
  {
    "w": "excuse",
    "c": "n. 借口，理由",
    "r": "v. 原谅，为……辩解",
    "e": "Please excuse my late reply.",
    "ez": "请原谅我回复晚了。"
  },
  {
    "w": "fare",
    "c": "n. 车费，票价",
    "r": "v. 进展，过活",
    "e": "The students fared well in the final exam.",
    "ez": "学生们在期末考试中表现不错。"
  },
  {
    "w": "fire",
    "c": "n. 火",
    "r": "v. 解雇；开火",
    "e": "He was fired for being late too often.",
    "ez": "他因频繁迟到被解雇。"
  },
  {
    "w": "fix",
    "c": "v. 修理，安装",
    "r": "v. 确定，安排",
    "e": "Let's fix a date for the next meeting.",
    "ez": "我们定一下下次会议的日期。"
  },
  {
    "w": "labour",
    "c": "n. 劳动，劳工",
    "r": "n. 分娩；v. 费力地行进",
    "e": "The old man laboured up the steep hill.",
    "ez": "老人吃力地爬上陡峭的山坡。"
  },
  {
    "w": "raw",
    "c": "adj. 生的，未加工的",
    "r": "adj. 湿冷的",
    "e": "The wind was raw and the sky was grey.",
    "ez": "风又湿又冷，天色灰暗。"
  },
  {
    "w": "respect",
    "c": "v./n. 尊敬，尊重",
    "r": "n. 方面，细节",
    "e": "In this respect, the plan still needs work.",
    "ez": "在这一方面，方案仍需改进。"
  },
  {
    "w": "search",
    "c": "n./v. 搜索，搜查",
    "r": "v. 搜（身）",
    "e": "The guard searched every bag at the gate.",
    "ez": "保安在门口检查了每个包。"
  },
  {
    "w": "seat",
    "c": "n. 座位",
    "r": "v. 使坐下；可容纳",
    "e": "The hall seats more than two thousand people.",
    "ez": "这个厅能容纳两千多人。"
  },
  {
    "w": "tie",
    "c": "v. 系，捆",
    "r": "n. 领带；束缚；（比赛）平局",
    "e": "The match ended in a two-all tie.",
    "ez": "比赛以二比二平局收场。"
  },
  {
    "w": "upset",
    "c": "adj. 心烦的，不安的",
    "r": "v. 打乱，推翻",
    "e": "The storm upset all our travel plans.",
    "ez": "暴风雨打乱了我们全部的出行计划。"
  },
  {
    "w": "direct",
    "c": "adj. 直接的",
    "r": "v. 指挥，指示",
    "e": "A policeman directed us to the nearest exit.",
    "ez": "一名警察指引我们到最近的出口。"
  },
  {
    "w": "final",
    "c": "adj. 最后的，最终的",
    "r": "n. 决赛；期末考试",
    "e": "She stayed up late preparing for the finals.",
    "ez": "她熬夜准备期末考试。"
  },
  {
    "w": "package",
    "c": "n. 包裹",
    "r": "v. 打包；包装推销",
    "e": "The trip is packaged as a study tour.",
    "ez": "这次行程被包装成一次游学。"
  },
  {
    "w": "tense",
    "c": "adj. 紧张的",
    "r": "n. 时态；v. 拉紧",
    "e": "Which tense should I use in this sentence?",
    "ez": "这句话该用哪种时态？"
  },
  {
    "w": "manual",
    "c": "adj. 手工的，体力的",
    "r": "n. 手册，指南",
    "e": "Read the manual before you use the machine.",
    "ez": "使用机器前请先阅读手册。"
  },
  {
    "w": "convert",
    "c": "v. 转变，转换",
    "r": "n. 皈依者，改变信仰的人",
    "e": "He became a convert to online learning.",
    "ez": "他成了在线学习的拥护者。"
  },
  {
    "w": "cue",
    "c": "n. 暗示，提示",
    "r": "v. 给……暗示",
    "e": "The teacher cued him when to start speaking.",
    "ez": "老师暗示他何时开始发言。"
  },
  {
    "w": "discard",
    "c": "v. 丢弃，抛弃",
    "r": "n. 被抛弃的人或物",
    "e": "These books are discards from the library.",
    "ez": "这些书是图书馆淘汰下来的。"
  },
  {
    "w": "ideal",
    "c": "adj. 理想的",
    "r": "n. 理想",
    "e": "He never gave up his ideals as a teacher.",
    "ez": "他从未放弃作为教师的理想。"
  },
  {
    "w": "prompt",
    "c": "adj. 及时的，迅速的",
    "r": "v. 促使，激起",
    "e": "The accident prompted a new safety rule.",
    "ez": "这起事故促使出台了新的安全规定。"
  },
  {
    "w": "reform",
    "c": "n./v. 改革",
    "r": "v. 改造，改过自新",
    "e": "The program helps young people reform themselves.",
    "ez": "该项目帮助年轻人改过自新。"
  },
  {
    "w": "reverse",
    "c": "v. 颠倒，翻转",
    "r": "n. 背面，相反",
    "e": "Read the instructions on the reverse of the paper.",
    "ez": "请阅读纸背面的说明。"
  },
  {
    "w": "bump",
    "c": "v. 撞，碰",
    "r": "adv. 突然地",
    "e": "The car stopped bump against the wall.",
    "ez": "汽车砰地一声撞在墙上停了下来。"
  },
  {
    "w": "blossom",
    "c": "n. 花，花朵",
    "r": "v. 开花；发展成",
    "e": "Their friendship blossomed into deep trust.",
    "ez": "他们的友谊发展成了深厚的信任。"
  },
  {
    "w": "bias",
    "c": "n. 偏见",
    "r": "v. 使有偏见；adj. 斜的",
    "e": "The report is biased against young workers.",
    "ez": "这份报告对年轻工人有偏见。"
  },
  {
    "w": "blend",
    "c": "v. 混合",
    "r": "n. 混合物",
    "e": "This tea is a blend of green and black leaves.",
    "ez": "这种茶是绿茶与红茶的混合。"
  },
  {
    "w": "browse",
    "c": "v. 浏览",
    "r": "v.（牲畜）吃草",
    "e": "Sheep were browsing on the hillside.",
    "ez": "羊在山坡上吃草。"
  },
  {
    "w": "partial",
    "c": "adj. 部分的",
    "r": "adj. 偏袒的，不公平的",
    "e": "The judge was accused of being partial.",
    "ez": "法官被指责有偏袒。"
  },
  {
    "w": "submit",
    "c": "v. 提交，呈递",
    "r": "v. 屈服，服从",
    "e": "He refused to submit to unfair treatment.",
    "ez": "他拒绝屈服于不公平的对待。"
  },
  {
    "w": "prevail",
    "c": "v. 盛行，流行",
    "r": "v. 获胜，占上风",
    "e": "Common sense prevailed over anger at last.",
    "ez": "最终理智战胜了愤怒。"
  },
  {
    "w": "exhaust",
    "c": "v. 使筋疲力尽",
    "r": "v. 用尽；n. 废气",
    "e": "The car produces far less exhaust now.",
    "ez": "这辆车现在的废气排放少多了。"
  },
  {
    "w": "household",
    "c": "n. 家庭，户",
    "r": "adj. 家用的，家庭的",
    "e": "Household spending on education keeps rising.",
    "ez": "家庭教育支出持续上升。"
  },
  {
    "w": "resolve",
    "c": "v. 解决",
    "r": "v. 决心，决定",
    "e": "She resolved to learn fifty words a day.",
    "ez": "她下定决心每天学五十个单词。"
  },
  {
    "w": "hostile",
    "c": "adj. 敌对的",
    "r": "adj. 强烈反对的，抵触的",
    "e": "He is hostile to any change in the plan.",
    "ez": "他对计划中的任何改动都很抵触。"
  },
  {
    "w": "anticipate",
    "c": "v. 预料，预期",
    "r": "v. 抢先行动",
    "e": "Our rivals anticipated the new policy and acted first.",
    "ez": "对手抢先一步针对新政策采取了行动。"
  },
  {
    "w": "accommodate",
    "c": "v. 容纳",
    "r": "v. 顺应，适应；提供住宿",
    "e": "The hotel can accommodate two hundred guests.",
    "ez": "这家酒店可接待两百位客人住宿。"
  },
  {
    "w": "asset",
    "c": "n. 资产，财产",
    "r": "n. 宝贵的人或品质",
    "e": "Her patience is a great asset to the team.",
    "ez": "她的耐心是团队的宝贵财富。"
  },
  {
    "w": "justify",
    "c": "v. 证明……是正当的",
    "r": "v. 为……辩护",
    "e": "Nothing can justify such rude behaviour.",
    "ez": "没有什么能为如此无礼的行为开脱。"
  },
  {
    "w": "reaction",
    "c": "n. 反应",
    "r": "n.（化学）反应；反动",
    "e": "The chemical reaction was observed in the lab.",
    "ez": "实验室里观察到了这一化学反应。"
  },
  {
    "w": "disguise",
    "c": "v. 假扮，伪装",
    "r": "n. 伪装物，掩饰",
    "e": "His smile was just a disguise for his anger.",
    "ez": "他的微笑只是掩饰愤怒的伪装。"
  },
  {
    "w": "restore",
    "c": "v. 恢复",
    "r": "v. 归还；修复",
    "e": "The museum restored the ancient painting.",
    "ez": "博物馆修复了这幅古画。"
  },
  {
    "w": "consolidate",
    "c": "v. 巩固，加强",
    "r": "v. 合并",
    "e": "The two classes were consolidated into one.",
    "ez": "两个班被合并成一个班。"
  },
  {
    "w": "invest",
    "c": "v. 投资",
    "r": "v. 投入（时间、精力）",
    "e": "She invested hours in reviewing new words.",
    "ez": "她投入了好几个小时复习新单词。"
  },
  {
    "w": "remote",
    "c": "adj. 偏远的",
    "r": "adj. 极小的，微乎其微的",
    "e": "There is only a remote chance of rain today.",
    "ez": "今天下雨的可能性极小。"
  },
  {
    "w": "coarse",
    "c": "adj. 粗糙的",
    "r": "adj. 粗俗的，粗鲁的",
    "e": "His coarse language shocked everyone at table.",
    "ez": "他粗俗的言辞让在座的人都吃了一惊。"
  },
  {
    "w": "genuine",
    "c": "adj. 真正的",
    "r": "adj. 真诚的",
    "e": "She showed genuine concern for her students.",
    "ez": "她对学生表现出真诚的关心。"
  },
  {
    "w": "oxygen",
    "c": "n. 氧气",
    "r": "n. 赖以生存的东西",
    "e": "Reading is the oxygen of a good writer.",
    "ez": "阅读是好作家赖以生存的东西。"
  }
];
export const CET4_TRANS = [
  {
    "p": "attach great importance to / give priority to",
    "m": "重视",
    "cat": "万能高分句型"
  },
  {
    "p": "take sth. into account / consideration",
    "m": "把某事考虑在内",
    "cat": "万能高分句型"
  },
  {
    "p": "be worth doing sth.",
    "m": "值得做某事",
    "cat": "万能高分句型"
  },
  {
    "p": "the second largest economy",
    "m": "第二大经济体",
    "cat": "万能高分句型"
  },
  {
    "p": "sth. depends on sth.",
    "m": "取决于某事",
    "cat": "万能高分句型"
  },
  {
    "p": "social status",
    "m": "社会地位",
    "cat": "万能高分句型"
  },
  {
    "p": "focus / spend time and energy on...",
    "m": "把时间和精力放在……上",
    "cat": "万能高分句型"
  },
  {
    "p": "both physically and mentally",
    "m": "身心两方面",
    "cat": "万能高分句型"
  },
  {
    "p": "set forth a compromise proposal",
    "m": "提出折中提议",
    "cat": "万能高分句型"
  },
  {
    "p": "a mirror of social progress",
    "m": "社会进步的反映",
    "cat": "万能高分句型"
  },
  {
    "p": "make full use of / take advantage of",
    "m": "充分利用",
    "cat": "万能高分句型"
  },
  {
    "p": "suffer from heavier pressure / heavier burden of",
    "m": "承受更大的压力",
    "cat": "万能高分句型"
  },
  {
    "p": "guarantee the stability and prosperity of the society",
    "m": "保障社会的稳定和繁荣",
    "cat": "万能高分句型"
  },
  {
    "p": "put more emphasis on...",
    "m": "更多地强调",
    "cat": "万能高分句型"
  },
  {
    "p": "adapt oneself to the development of society",
    "m": "适应社会发展",
    "cat": "万能高分句型"
  },
  {
    "p": "range from... to...",
    "m": "从……到……；在……范围内变动",
    "cat": "万能高分句型"
  },
  {
    "p": "the main reasons are listed as follows",
    "m": "主要理由列举如下",
    "cat": "万能高分句型"
  },
  {
    "p": "an irresistible trend of...",
    "m": "……的必然趋势",
    "cat": "万能高分句型"
  },
  {
    "p": "the increasingly fierce / keen social competition",
    "m": "日益激烈的社会竞争",
    "cat": "万能高分句型"
  },
  {
    "p": "immediate interest / short-term interest",
    "m": "眼前利益",
    "cat": "万能高分句型"
  },
  {
    "p": "interest in the long run",
    "m": "长远利益",
    "cat": "万能高分句型"
  },
  {
    "p": "has its merits and demerits / advantages and disadvantages",
    "m": "有其自身的优缺点",
    "cat": "万能高分句型"
  },
  {
    "p": "exploit to the full one's favorable conditions and avoid unfavorable ones",
    "m": "扬长避短",
    "cat": "万能高分句型"
  },
  {
    "p": "take the essence and discard the dross",
    "m": "取其精华，去其糟粕",
    "cat": "万能高分句型"
  },
  {
    "p": "do harm to / be harmful to / be detrimental to",
    "m": "对……有害",
    "cat": "万能高分句型"
  },
  {
    "p": "exchange ideas / emotions / information",
    "m": "交流思想/情感/信息",
    "cat": "万能高分句型"
  },
  {
    "p": "take effective measures to do sth.",
    "m": "采取有效措施来……",
    "cat": "万能高分句型"
  },
  {
    "p": "the healthy development of...",
    "m": "……的健康发展",
    "cat": "万能高分句型"
  },
  {
    "p": "not to speak of / not to mention / let alone",
    "m": "更不要说",
    "cat": "万能高分句型"
  },
  {
    "p": "every coin has two sides",
    "m": "有利有弊",
    "cat": "万能高分句型"
  },
  {
    "p": "prior to",
    "m": "在……之前",
    "cat": "万能高分句型"
  },
  {
    "p": "financial burden / psychological burden",
    "m": "经济/心理负担",
    "cat": "万能高分句型"
  },
  {
    "p": "take many factors into account / consideration",
    "m": "考虑到诸多因素",
    "cat": "万能高分句型"
  },
  {
    "p": "from another perspective",
    "m": "从另一个角度",
    "cat": "万能高分句型"
  },
  {
    "p": "make joint efforts",
    "m": "做出共同努力",
    "cat": "万能高分句型"
  },
  {
    "p": "be beneficial / conducive to",
    "m": "对……有益",
    "cat": "万能高分句型"
  },
  {
    "p": "make contributions to the society",
    "m": "为社会做贡献",
    "cat": "万能高分句型"
  },
  {
    "p": "lay a solid foundation for",
    "m": "打下坚实的基础",
    "cat": "万能高分句型"
  },
  {
    "p": "comprehensive quality",
    "m": "综合素质",
    "cat": "万能高分句型"
  },
  {
    "p": "be committed / devoted to",
    "m": "致力于/投身于",
    "cat": "万能高分句型"
  },
  {
    "p": "an indispensable duty",
    "m": "不可推卸的义务",
    "cat": "万能高分句型"
  },
  {
    "p": "satisfy / meet the needs / requirements of",
    "m": "满足……的需求",
    "cat": "万能高分句型"
  },
  {
    "p": "valuable natural resources",
    "m": "宝贵的自然资源",
    "cat": "万能高分句型"
  },
  {
    "p": "convenient and efficient",
    "m": "方便快捷",
    "cat": "万能高分句型"
  },
  {
    "p": "in all aspects of human life",
    "m": "在人类生活的方方面面",
    "cat": "万能高分句型"
  },
  {
    "p": "a symbol of social progress",
    "m": "社会进步的体现",
    "cat": "万能高分句型"
  },
  {
    "p": "the accelerated updating of science and technology",
    "m": "科技的飞速更新",
    "cat": "万能高分句型"
  },
  {
    "p": "have / provide the following reasons / evidence",
    "m": "有/提供如下理由/证据",
    "cat": "万能高分句型"
  },
  {
    "p": "to some extent / degree; in some way",
    "m": "在一定程度上",
    "cat": "万能高分句型"
  },
  {
    "p": "integrate theory with practice / apply theory to practice",
    "m": "理论和实践相结合",
    "cat": "万能高分句型"
  },
  {
    "p": "play an increasingly important / vital role in",
    "m": "在……中发挥着日益重要的作用",
    "cat": "万能高分句型"
  },
  {
    "p": "be indispensable to",
    "m": "对……必不可少",
    "cat": "万能高分句型"
  },
  {
    "p": "as the proverb goes; as can be seen from the picture",
    "m": "正如谚语所说/如图所示",
    "cat": "万能高分句型"
  },
  {
    "p": "be no exception",
    "m": "也不例外",
    "cat": "万能高分句型"
  },
  {
    "p": "exert positive / negative effects on",
    "m": "对……产生有利/不利的影响",
    "cat": "万能高分句型"
  },
  {
    "p": "the advantages far outweigh the disadvantages",
    "m": "利远远大于弊",
    "cat": "万能高分句型"
  },
  {
    "p": "lead to / give rise to / contribute to / result in",
    "m": "导致，引起",
    "cat": "万能高分句型"
  },
  {
    "p": "a complicated social phenomenon",
    "m": "复杂的社会现象",
    "cat": "万能高分句型"
  },
  {
    "p": "sense of responsibility / sense of achievement",
    "m": "责任感/成就感",
    "cat": "万能高分句型"
  },
  {
    "p": "sense of competition and cooperation",
    "m": "竞争与合作精神",
    "cat": "万能高分句型"
  },
  {
    "p": "widen one's horizon / broaden one's vision",
    "m": "开阔眼界",
    "cat": "万能高分句型"
  },
  {
    "p": "seven billion",
    "m": "七十亿",
    "cat": "万能高分句型"
  },
  {
    "p": "acquire knowledge and skills",
    "m": "学习知识和技能",
    "cat": "万能高分句型"
  },
  {
    "p": "can't help doing sth.",
    "m": "禁不住做某事",
    "cat": "万能高分句型"
  },
  {
    "p": "have difficulty (trouble) (in) doing sth.",
    "m": "做……有困难",
    "cat": "万能高分句型"
  },
  {
    "p": "It's no use doing sth.",
    "m": "做某事毫无用处",
    "cat": "万能高分句型"
  },
  {
    "p": "There's no point in doing sth.",
    "m": "没必要做某事",
    "cat": "万能高分句型"
  },
  {
    "p": "have an influence on sth. / sb.",
    "m": "对某事/某人有影响",
    "cat": "万能高分句型"
  },
  {
    "p": "impose sth. on sb.",
    "m": "把……强加于某人",
    "cat": "万能高分句型"
  },
  {
    "p": "escape doing sth.",
    "m": "避免做某事",
    "cat": "万能高分句型"
  },
  {
    "p": "accuse sb. of sth.",
    "m": "控告某人做某事",
    "cat": "万能高分句型"
  },
  {
    "p": "be alert to sth.",
    "m": "对……保持警惕",
    "cat": "万能高分句型"
  },
  {
    "p": "be second to none",
    "m": "不比任何人差，首屈一指",
    "cat": "万能高分句型"
  },
  {
    "p": "have no objection to doing sth.",
    "m": "同意做某事",
    "cat": "万能高分句型"
  },
  {
    "p": "confess to",
    "m": "承认",
    "cat": "万能高分句型"
  },
  {
    "p": "resort to",
    "m": "诉诸于",
    "cat": "万能高分句型"
  },
  {
    "p": "take on",
    "m": "雇佣，呈现，从事",
    "cat": "万能高分句型"
  },
  {
    "p": "throw / cast light on",
    "m": "使明白，阐明",
    "cat": "万能高分句型"
  },
  {
    "p": "interfere in",
    "m": "干涉",
    "cat": "万能高分句型"
  },
  {
    "p": "traditional Chinese culture",
    "m": "中国传统文化",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "etiquette",
    "m": "礼节，礼仪",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "exchange gifts",
    "m": "互赠礼物",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "social interaction",
    "m": "人际交往",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "emotional expression",
    "m": "情感的表达",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "a bond that maintains interpersonal relationships",
    "m": "维系人际关系的纽带",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "a carefully chosen gift",
    "m": "精心挑选的礼物",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "express gratitude",
    "m": "表达感激",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "show respect for the elders",
    "m": "尊敬长辈",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "be deeply rooted in",
    "m": "深深植根于",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "pass down from generation to generation",
    "m": "代代相传",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "cultural heritage",
    "m": "文化遗产",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "customs and traditions",
    "m": "风俗传统",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "symbolize",
    "m": "象征",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "convey good wishes",
    "m": "传达美好祝愿",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "family reunion",
    "m": "家庭团聚",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "value harmony",
    "m": "崇尚和谐",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "filial piety",
    "m": "孝道",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "modesty",
    "m": "谦逊",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "hospitality",
    "m": "好客",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "the Spring Festival couplets",
    "m": "春联",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "a red envelope",
    "m": "红包",
    "cat": "传统文化与礼仪"
  },
  {
    "p": "the Spring Festival",
    "m": "春节",
    "cat": "传统节日"
  },
  {
    "p": "the Mid-Autumn Festival",
    "m": "中秋节",
    "cat": "传统节日"
  },
  {
    "p": "the Dragon Boat Festival",
    "m": "端午节",
    "cat": "传统节日"
  },
  {
    "p": "the Lantern Festival",
    "m": "元宵节",
    "cat": "传统节日"
  },
  {
    "p": "the Double Ninth Festival",
    "m": "重阳节",
    "cat": "传统节日"
  },
  {
    "p": "the lunar calendar",
    "m": "农历",
    "cat": "传统节日"
  },
  {
    "p": "the eve of the Spring Festival",
    "m": "除夕",
    "cat": "传统节日"
  },
  {
    "p": "have a reunion dinner",
    "m": "吃年夜饭",
    "cat": "传统节日"
  },
  {
    "p": "stay up late on New Year's Eve",
    "m": "守岁",
    "cat": "传统节日"
  },
  {
    "p": "lucky money / gift money",
    "m": "压岁钱",
    "cat": "传统节日"
  },
  {
    "p": "set off firecrackers",
    "m": "放鞭炮",
    "cat": "传统节日"
  },
  {
    "p": "dragon boat racing",
    "m": "赛龙舟",
    "cat": "传统节日"
  },
  {
    "p": "moon cakes",
    "m": "月饼",
    "cat": "传统节日"
  },
  {
    "p": "enjoy the full moon",
    "m": "赏月",
    "cat": "传统节日"
  },
  {
    "p": "decorate with lanterns",
    "m": "用灯笼装饰",
    "cat": "传统节日"
  },
  {
    "p": "pay a New Year call",
    "m": "拜年",
    "cat": "传统节日"
  },
  {
    "p": "celebrate the festival",
    "m": "庆祝节日",
    "cat": "传统节日"
  },
  {
    "p": "a public holiday",
    "m": "法定假日",
    "cat": "传统节日"
  },
  {
    "p": "a traditional festival",
    "m": "传统节日",
    "cat": "传统节日"
  },
  {
    "p": "a family get-together",
    "m": "家庭聚会",
    "cat": "传统节日"
  },
  {
    "p": "paper cutting",
    "m": "剪纸",
    "cat": "民间艺术"
  },
  {
    "p": "a Chinese knot",
    "m": "中国结",
    "cat": "民间艺术"
  },
  {
    "p": "shadow puppetry",
    "m": "皮影戏",
    "cat": "民间艺术"
  },
  {
    "p": "Peking Opera",
    "m": "京剧",
    "cat": "民间艺术"
  },
  {
    "p": "Kunqu Opera",
    "m": "昆曲",
    "cat": "民间艺术"
  },
  {
    "p": "Chinese calligraphy",
    "m": "中国书法",
    "cat": "民间艺术"
  },
  {
    "p": "traditional Chinese painting",
    "m": "国画",
    "cat": "民间艺术"
  },
  {
    "p": "embroidery",
    "m": "刺绣",
    "cat": "民间艺术"
  },
  {
    "p": "porcelain",
    "m": "瓷器",
    "cat": "民间艺术"
  },
  {
    "p": "a clay figurine",
    "m": "泥人",
    "cat": "民间艺术"
  },
  {
    "p": "wood carving",
    "m": "木雕",
    "cat": "民间艺术"
  },
  {
    "p": "folk art",
    "m": "民间艺术",
    "cat": "民间艺术"
  },
  {
    "p": "intangible cultural heritage",
    "m": "非物质文化遗产",
    "cat": "民间艺术"
  },
  {
    "p": "handicraft",
    "m": "手工艺",
    "cat": "民间艺术"
  },
  {
    "p": "be listed as",
    "m": "被列为",
    "cat": "民间艺术"
  },
  {
    "p": "a distinctive national feature",
    "m": "鲜明的民族特色",
    "cat": "民间艺术"
  },
  {
    "p": "artistic value",
    "m": "艺术价值",
    "cat": "民间艺术"
  },
  {
    "p": "inherit and carry forward",
    "m": "传承和弘扬",
    "cat": "民间艺术"
  },
  {
    "p": "a craftsman",
    "m": "手工艺人",
    "cat": "民间艺术"
  },
  {
    "p": "a symbol of good luck",
    "m": "好运的象征",
    "cat": "民间艺术"
  },
  {
    "p": "Chinese cuisine",
    "m": "中国菜",
    "cat": "饮食文化"
  },
  {
    "p": "staple food",
    "m": "主食",
    "cat": "饮食文化"
  },
  {
    "p": "hot pot",
    "m": "火锅",
    "cat": "饮食文化"
  },
  {
    "p": "dumplings",
    "m": "饺子",
    "cat": "饮食文化"
  },
  {
    "p": "noodles",
    "m": "面条",
    "cat": "饮食文化"
  },
  {
    "p": "tea culture",
    "m": "茶文化",
    "cat": "饮食文化"
  },
  {
    "p": "green tea",
    "m": "绿茶",
    "cat": "饮食文化"
  },
  {
    "p": "Longjing tea",
    "m": "龙井茶",
    "cat": "饮食文化"
  },
  {
    "p": "a wide variety of",
    "m": "各种各样的",
    "cat": "饮食文化"
  },
  {
    "p": "be famous for",
    "m": "以……闻名",
    "cat": "饮食文化"
  },
  {
    "p": "a balanced diet",
    "m": "均衡的饮食",
    "cat": "饮食文化"
  },
  {
    "p": "cooking methods",
    "m": "烹饪方法",
    "cat": "饮食文化"
  },
  {
    "p": "flavor",
    "m": "风味，口味",
    "cat": "饮食文化"
  },
  {
    "p": "spicy",
    "m": "辣的",
    "cat": "饮食文化"
  },
  {
    "p": "nutritious",
    "m": "有营养的",
    "cat": "饮食文化"
  },
  {
    "p": "table manners",
    "m": "餐桌礼仪",
    "cat": "饮食文化"
  },
  {
    "p": "use chopsticks",
    "m": "使用筷子",
    "cat": "饮食文化"
  },
  {
    "p": "food safety",
    "m": "食品安全",
    "cat": "饮食文化"
  },
  {
    "p": "a traditional snack",
    "m": "传统小吃",
    "cat": "饮食文化"
  },
  {
    "p": "be popular with",
    "m": "受……欢迎",
    "cat": "饮食文化"
  },
  {
    "p": "the Great Wall",
    "m": "长城",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "the Palace Museum",
    "m": "故宫",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "the Yangtze River",
    "m": "长江",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "the Yellow River",
    "m": "黄河",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "Mount Tai",
    "m": "泰山",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "Mount Huang",
    "m": "黄山",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "the Grand Canal",
    "m": "大运河",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "the Silk Road",
    "m": "丝绸之路",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "a place of interest",
    "m": "名胜古迹",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "a scenic spot",
    "m": "景点",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "be located in",
    "m": "位于",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "stretch for",
    "m": "绵延",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "cover an area of",
    "m": "占地",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "attract tourists from home and abroad",
    "m": "吸引国内外游客",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "natural landscape",
    "m": "自然景观",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "world cultural heritage",
    "m": "世界文化遗产",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "a long history of",
    "m": "悠久的……历史",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "ancient architecture",
    "m": "古代建筑",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "climb the mountain",
    "m": "爬山",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "the Terracotta Warriors",
    "m": "兵马俑",
    "cat": "名胜古迹与地理"
  },
  {
    "p": "high-speed railway",
    "m": "高铁",
    "cat": "经济与商业"
  },
  {
    "p": "mobile payment",
    "m": "移动支付",
    "cat": "经济与商业"
  },
  {
    "p": "the sharing economy",
    "m": "共享经济",
    "cat": "经济与商业"
  },
  {
    "p": "online shopping",
    "m": "网上购物",
    "cat": "经济与商业"
  },
  {
    "p": "e-commerce",
    "m": "电子商务",
    "cat": "经济与商业"
  },
  {
    "p": "the world's second largest economy",
    "m": "世界第二大经济体",
    "cat": "经济与商业"
  },
  {
    "p": "economic growth",
    "m": "经济增长",
    "cat": "经济与商业"
  },
  {
    "p": "raise the living standard",
    "m": "提高生活水平",
    "cat": "经济与商业"
  },
  {
    "p": "per capita income",
    "m": "人均收入",
    "cat": "经济与商业"
  },
  {
    "p": "boost the local economy",
    "m": "促进当地经济发展",
    "cat": "经济与商业"
  },
  {
    "p": "purchasing power",
    "m": "购买力",
    "cat": "经济与商业"
  },
  {
    "p": "a huge market potential",
    "m": "巨大的市场潜力",
    "cat": "经济与商业"
  },
  {
    "p": "domestic demand",
    "m": "国内需求",
    "cat": "经济与商业"
  },
  {
    "p": "be open to the outside world",
    "m": "对外开放",
    "cat": "经济与商业"
  },
  {
    "p": "promote trade cooperation",
    "m": "促进贸易合作",
    "cat": "经济与商业"
  },
  {
    "p": "modernization",
    "m": "现代化",
    "cat": "经济与商业"
  },
  {
    "p": "urbanization",
    "m": "城镇化",
    "cat": "经济与商业"
  },
  {
    "p": "a leading enterprise",
    "m": "龙头企业",
    "cat": "经济与商业"
  },
  {
    "p": "brand awareness",
    "m": "品牌知名度",
    "cat": "经济与商业"
  },
  {
    "p": "consumer goods",
    "m": "消费品",
    "cat": "经济与商业"
  },
  {
    "p": "artificial intelligence",
    "m": "人工智能",
    "cat": "科技与创新"
  },
  {
    "p": "5G technology",
    "m": "5G 技术",
    "cat": "科技与创新"
  },
  {
    "p": "the space station",
    "m": "空间站",
    "cat": "科技与创新"
  },
  {
    "p": "launch a satellite",
    "m": "发射卫星",
    "cat": "科技与创新"
  },
  {
    "p": "technological innovation",
    "m": "科技创新",
    "cat": "科技与创新"
  },
  {
    "p": "scientific research",
    "m": "科学研究",
    "cat": "科技与创新"
  },
  {
    "p": "cutting-edge technology",
    "m": "前沿技术",
    "cat": "科技与创新"
  },
  {
    "p": "make a breakthrough",
    "m": "取得突破",
    "cat": "科技与创新"
  },
  {
    "p": "the digital economy",
    "m": "数字经济",
    "cat": "科技与创新"
  },
  {
    "p": "a smart phone",
    "m": "智能手机",
    "cat": "科技与创新"
  },
  {
    "p": "application",
    "m": "应用",
    "cat": "科技与创新"
  },
  {
    "p": "improve efficiency",
    "m": "提高效率",
    "cat": "科技与创新"
  },
  {
    "p": "online education",
    "m": "在线教育",
    "cat": "科技与创新"
  },
  {
    "p": "big data",
    "m": "大数据",
    "cat": "科技与创新"
  },
  {
    "p": "the Internet of Things",
    "m": "物联网",
    "cat": "科技与创新"
  },
  {
    "p": "a driverless car",
    "m": "无人驾驶汽车",
    "cat": "科技与创新"
  },
  {
    "p": "bring convenience to people's life",
    "m": "为人们的生活带来便利",
    "cat": "科技与创新"
  },
  {
    "p": "change people's way of life",
    "m": "改变人们的生活方式",
    "cat": "科技与创新"
  },
  {
    "p": "independent innovation",
    "m": "自主创新",
    "cat": "科技与创新"
  },
  {
    "p": "with the rapid development of",
    "m": "随着……的快速发展",
    "cat": "科技与创新"
  },
  {
    "p": "compulsory education",
    "m": "义务教育",
    "cat": "教育与人才"
  },
  {
    "p": "higher education",
    "m": "高等教育",
    "cat": "教育与人才"
  },
  {
    "p": "the college entrance examination",
    "m": "高考",
    "cat": "教育与人才"
  },
  {
    "p": "tuition fee",
    "m": "学费",
    "cat": "教育与人才"
  },
  {
    "p": "scholarship",
    "m": "奖学金",
    "cat": "教育与人才"
  },
  {
    "p": "a well-rounded student",
    "m": "全面发展的学生",
    "cat": "教育与人才"
  },
  {
    "p": "quality-oriented education",
    "m": "素质教育",
    "cat": "教育与人才"
  },
  {
    "p": "acquire knowledge",
    "m": "获取知识",
    "cat": "教育与人才"
  },
  {
    "p": "broaden one's horizons",
    "m": "开阔视野",
    "cat": "教育与人才"
  },
  {
    "p": "lifelong learning",
    "m": "终身学习",
    "cat": "教育与人才"
  },
  {
    "p": "talent cultivation",
    "m": "人才培养",
    "cat": "教育与人才"
  },
  {
    "p": "the aging society",
    "m": "老龄化社会",
    "cat": "教育与人才"
  },
  {
    "p": "the enrolment rate",
    "m": "入学率",
    "cat": "教育与人才"
  },
  {
    "p": "study abroad",
    "m": "出国留学",
    "cat": "教育与人才"
  },
  {
    "p": "academic performance",
    "m": "学习成绩",
    "cat": "教育与人才"
  },
  {
    "p": "put knowledge into practice",
    "m": "把知识付诸实践",
    "cat": "教育与人才"
  },
  {
    "p": "attach importance to",
    "m": "注重",
    "cat": "教育与人才"
  },
  {
    "p": "develop one's potential",
    "m": "发挥潜能",
    "cat": "教育与人才"
  },
  {
    "p": "the gap between the rich and the poor",
    "m": "贫富差距",
    "cat": "教育与人才"
  },
  {
    "p": "a large population of",
    "m": "人口众多的",
    "cat": "教育与人才"
  },
  {
    "p": "environmental protection",
    "m": "环境保护",
    "cat": "环境与健康"
  },
  {
    "p": "air pollution",
    "m": "空气污染",
    "cat": "环境与健康"
  },
  {
    "p": "climate change",
    "m": "气候变化",
    "cat": "环境与健康"
  },
  {
    "p": "renewable energy",
    "m": "可再生能源",
    "cat": "环境与健康"
  },
  {
    "p": "solar energy",
    "m": "太阳能",
    "cat": "环境与健康"
  },
  {
    "p": "green development",
    "m": "绿色发展",
    "cat": "环境与健康"
  },
  {
    "p": "reduce carbon emissions",
    "m": "减少碳排放",
    "cat": "环境与健康"
  },
  {
    "p": "waste sorting",
    "m": "垃圾分类",
    "cat": "环境与健康"
  },
  {
    "p": "recycle",
    "m": "回收利用",
    "cat": "环境与健康"
  },
  {
    "p": "eco-friendly",
    "m": "环保的",
    "cat": "环境与健康"
  },
  {
    "p": "a healthy lifestyle",
    "m": "健康的生活方式",
    "cat": "环境与健康"
  },
  {
    "p": "physical exercise",
    "m": "体育锻炼",
    "cat": "环境与健康"
  },
  {
    "p": "mental health",
    "m": "心理健康",
    "cat": "环境与健康"
  },
  {
    "p": "get enough sleep",
    "m": "保证充足睡眠",
    "cat": "环境与健康"
  },
  {
    "p": "relieve pressure",
    "m": "缓解压力",
    "cat": "环境与健康"
  },
  {
    "p": "be good for one's health",
    "m": "有益于健康",
    "cat": "环境与健康"
  },
  {
    "p": "the public's awareness of",
    "m": "公众的……意识",
    "cat": "环境与健康"
  },
  {
    "p": "raise the awareness of environmental protection",
    "m": "提高环保意识",
    "cat": "环境与健康"
  },
  {
    "p": "sustainable development",
    "m": "可持续发展",
    "cat": "环境与健康"
  },
  {
    "p": "be harmful to one's health",
    "m": "有害健康",
    "cat": "环境与健康"
  },
  {
    "p": "a time-honoured history",
    "m": "悠久的历史",
    "cat": "历史与对外交流"
  },
  {
    "p": "date back to",
    "m": "追溯到",
    "cat": "历史与对外交流"
  },
  {
    "p": "be founded in",
    "m": "建立于",
    "cat": "历史与对外交流"
  },
  {
    "p": "the Tang Dynasty",
    "m": "唐朝",
    "cat": "历史与对外交流"
  },
  {
    "p": "the Ming Dynasty",
    "m": "明朝",
    "cat": "历史与对外交流"
  },
  {
    "p": "ancient civilization",
    "m": "古代文明",
    "cat": "历史与对外交流"
  },
  {
    "p": "cultural exchange",
    "m": "文化交流",
    "cat": "历史与对外交流"
  },
  {
    "p": "friendly relations",
    "m": "友好关系",
    "cat": "历史与对外交流"
  },
  {
    "p": "mutual understanding",
    "m": "相互理解",
    "cat": "历史与对外交流"
  },
  {
    "p": "promote cooperation",
    "m": "促进合作",
    "cat": "历史与对外交流"
  },
  {
    "p": "play an important role in",
    "m": "在……中发挥重要作用",
    "cat": "历史与对外交流"
  },
  {
    "p": "be widely recognized",
    "m": "被广泛认可",
    "cat": "历史与对外交流"
  },
  {
    "p": "have a profound influence on",
    "m": "对……产生深远影响",
    "cat": "历史与对外交流"
  },
  {
    "p": "the Belt and Road Initiative",
    "m": "一带一路倡议",
    "cat": "历史与对外交流"
  },
  {
    "p": "cultural diversity",
    "m": "文化多样性",
    "cat": "历史与对外交流"
  },
  {
    "p": "learn from each other",
    "m": "相互学习",
    "cat": "历史与对外交流"
  },
  {
    "p": "a trade route",
    "m": "贸易路线",
    "cat": "历史与对外交流"
  },
  {
    "p": "contribute to world peace",
    "m": "为世界和平做贡献",
    "cat": "历史与对外交流"
  },
  {
    "p": "gain popularity",
    "m": "受欢迎",
    "cat": "历史与对外交流"
  },
  {
    "p": "go global",
    "m": "走向世界",
    "cat": "历史与对外交流"
  }
];
